import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/products/attributes/colours'

const ProductAttributeColoursApiV2 = {
  /**
   * Get list of `Product Colour`
   * @param {object} params uri parameter
   * @return {object} Collection of `Colour Filter`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },
  /**
   * Create new Colour options
   * @param {string} label colour name
   * @param {string} hex_code colour hex code
   */
  create: async ({ label, hex_code, product_colour_filter_ids }) => {
    const payload  = {
      label                     : label,
      hex_code                  : hex_code,
      product_colour_filter_ids : product_colour_filter_ids
    }
    const response = axios.post(API_PATH, payload)
    return response
  },
  /**
   * update existing colour options
   * @param {string} id colour id
   * @param {string} label colour name
   * @param {string} hex_code colour hex code
   */
  update: async ({ id, label, hex_code, product_colour_filter_ids }) => {
    const endpoint = `${API_PATH}/${id}`
    const payload  = {
      label                     : label,
      hex_code                  : hex_code,
      product_colour_filter_ids : product_colour_filter_ids
    }
    const response = axios.patch(endpoint, payload)
    return response
  },

  /**
   * Get list of `Product Colour Filter`
   * @param {object} params uri parameter
   * @return {object} Collection of `Colour Filter`
   */
  getFilter: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = `${API_PATH}/filters`

    const response = axios.get(path, { params })
    return response
  }
}

export default ProductAttributeColoursApiV2